<div class="pnl-promotion">
  <header>
    <div>
      <button (click)="onBack()" class="btn btn-primary-outline">Voltar</button>
      <button
        (click)="onCancelPromotion()"
        [disabled]="promotion == null"
        type="button"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button
        (click)="onSubmit()"
        type="button"
        [disabled]="!changeDetail"
        class="btn btn-primary"
      >
        Salvar
      </button>
    </div>
  </header>

  <form [formGroup]="promotionFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div class="pnl dados">
        <div class="prelative">
          <strong>Descrição</strong>
          <label>Descreva a promoção</label>
          <input
            type="text"
            class="form-control"
            (keyup)="onChangeDetail()"
            formControlName="descricao"
          />

          <div *ngIf="isMatriz" class="mt20">
            <mat-checkbox
              id="aplicarFiliais"
              (change)="onChangeDetail()"
              formControlName="aplicar_filiais"
              class="asfs"
              [class.ck-promocao]="aplicar_filiais.value"
              >Aplicar promoção em todas filiais</mat-checkbox
            >
          </div>

          <div class="action-status">
            <div class="ipt-switch">
              <input
                id="ckStatus"
                type="checkbox"
                (change)="onChangeDetail()"
                formControlName="status"
                name="status"
              />
              <label for="ckStatus"></label>
            </div>
            <span>{{ status.value ? "Ativar" : "Inativar" }}</span>
          </div>
        </div>

        <div>
          <strong>Promoção</strong>
          <label>Tipo de promoção</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              (change)="onChangeTypePromotion()"
              formControlName="aplica"
              [items]="aplica_list"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div *ngIf="aplica.value == 'F' && seleciona.value != 'G'">
              <ng-select
                placeholder="Selecione..."
                (change)="onChangeDetail()"
                formControlName="desconto_modo"
                [items]="desconto_modo_list"
                bindLabel="text"
                bindValue="value"
              ></ng-select>
            </div>
          </div>
        </div>

        <div>
          <strong>Seleção</strong>
          <label>Item de seleção</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              formControlName="seleciona"
              [items]="seleciona_list"
              (change)="onChangeTypeSelection()"
              bindLabel="text"
              bindValue="value"
              [readonly]="aplica.value == 'C'"
            ></ng-select>
            <div *ngIf="seleciona.value == 'M'" class="tipo_desconto">
              <input
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control"
                formControlName="marca"
              />
            </div>
            <div
              *ngIf="
                seleciona.value == 'C' &&
                (desconto_modo.value == 'C' || aplica.value == 'G')
              "
              class="tipo_desconto"
            >
              <input
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control ti20"
                formControlName="total"
                currencyMask
                placeholder="0"
              />
              <span class="valor">R$</span>
            </div>
            <button
              *ngIf="seleciona.value == 'L' || aplica.value == 'C'"
              (click)="openModalProducts('P')"
              type="button"
              class="btn btn-primary-outline btn-tag"
            >
              <b *ngIf="produtos.length > 0">{{ produtos.length }}</b>
              Pesquisar produtos
            </button>
          </div>
        </div>

        <div *ngIf="aplica.value == 'G'" class="condicao">
          <strong>Condição</strong>
          <label>Pedidos com a forma de entrega</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              formControlName="tipo_condicao"
              [items]="tipo_condicao_list"
              (change)="onChangeDetail()"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div *ngIf="tipo_condicao.value" class="tipo_desconto">
              <input
                id="fileUploader"
                #fileUploader
                type="file"
                ng2FileSelect
                [uploader]="uploader"
                class="dnone"
              />

              <button
                (click)="fileUploader.click()"
                type="button"
                class="btn btn-primary-outline"
              >
                Adicionar selo
              </button>
            </div>
          </div>
          <div *ngIf="tipo_condicao.value" class="image">
            <div
              *ngIf="
                (uploader.queue && uploader.queue.length > 0) || imageSelo != ''
              "
              class="image-selo"
            >
              <img [src]="imageSelo" *ngIf="imageSelo != ''" class="capa" />
              <img
                *ngFor="let item of uploader.queue; let i = index"
                src=""
                imgPreview
                [image]="item?._file"
                class="capa"
              />
            </div>
            <div
              *ngIf="
                (uploader.queue && uploader.queue.length > 0) || imageSelo != ''
              "
            >
              <button
                (click)="onRemoveImage()"
                type="button"
                class="btn btn-danger-outline"
              >
                Remover selo
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="seleciona.value != 'C' && desconto_modo.value == 'C'">
          <strong>Requisito</strong>
          <label>Requisito para a promoção</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              formControlName="tipo_requisito"
              [items]="tipo_requisito_list"
              (change)="onChangeDetail()"
              bindLabel="text"
              bindValue="value"
              [readonly]="aplica.value == 'C'"
            ></ng-select>
            <div class="tipo_desconto">
              <input
                *ngIf="tipo_requisito.value == 'V'"
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control ti20"
                formControlName="total"
                currencyMask
                placeholder="0"
              />
              <input
                *ngIf="tipo_requisito.value == 'Q'"
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control"
                formControlName="quantidade"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                placeholder="0"
              />
              <span *ngIf="tipo_requisito.value == 'V'" class="valor">R$</span>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            (aplica.value == 'F' || aplica.value == 'C') &&
            desconto_modo.value == 'C'
          "
        >
          <strong>Desconto</strong>
          <label>Valor do desconto</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              (change)="onChangeDetail()"
              formControlName="tipo_desconto"
              [items]="tipo_desconto_list"
              bindLabel="text"
              bindValue="value"
              [readonly]="aplica.value == 'C'"
            ></ng-select>
            <div class="tipo_desconto">
              <input
                type="text"
                class="form-control"
                (keyup)="onChangeDetail()"
                [class.ti20]="tipo_desconto.value == 'F'"
                currencyMask
                [options]="{ precision: 2, allowNegative: false }"
                formControlName="valor"
                placeholder="0"
              />
              <span class="valor" *ngIf="tipo_desconto.value == 'F'">R$</span>
              <span class="percentual" *ngIf="tipo_desconto.value == 'P'"
                >%</span
              >
            </div>
          </div>
        </div>

        <div
          *ngIf="aplica.value == 'F' && desconto_modo.value == 'P'"
          formArrayName="valores"
        >
          <strong>Desconto</strong>
          <label>Valores para desconto</label>
          <div
            class="form-col-4"
            *ngFor="let grp_valores of valores.controls; let i = index"
            [formGroupName]="i"
            [class.dnone]="grp_valores.controls.valor.value == -1"
          >
            <ng-select
              *ngIf="seleciona.value != 'C'"
              placeholder="Selecione..."
              formControlName="tipo_requisito"
              [items]="tipo_requisito_list"
              (change)="onChangeDetail()"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div *ngIf="seleciona.value == 'C'" class="label">
              Valor mínimo de
            </div>
            <div class="tipo_desconto">
              <input
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control"
                [class.ti20]="
                  tipo_requisito.value == 'V' || seleciona.value == 'C'
                "
                formControlName="valor"
                currencyMask
                [options]="
                  configRequisito(grp_valores.controls.tipo_requisito.value)
                "
                placeholder="0"
              />
              <span
                *ngIf="tipo_requisito.value == 'V' || seleciona.value == 'C'"
                class="valor"
                >R$</span
              >
            </div>

            <ng-select
              placeholder="Selecione..."
              (change)="onChangeDetail()"
              formControlName="tipo_desconto"
              [items]="tipo_desconto_list"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div class="tipo_desconto">
              <input
                type="text"
                class="form-control"
                (keyup)="onChangeDetail()"
                [class.ti20]="grp_valores.controls.tipo_desconto.value == 'F'"
                currencyMask
                [options]="{ precision: 2, allowNegative: false }"
                formControlName="desconto"
                placeholder="0"
              />
              <span
                class="valor"
                *ngIf="grp_valores.controls.tipo_desconto.value == 'F'"
                >R$</span
              >
              <span
                class="percentual"
                *ngIf="grp_valores.controls.tipo_desconto.value == 'P'"
                >%</span
              >
            </div>

            <div class="actions">
              <a (click)="onRemoveValue(i)" class="btn-close-round"></a>
            </div>
          </div>
          <div>
            <button
              (click)="onAddValue(undefined)"
              type="button"
              class="btn btn-green-outline"
            >
              <span>
                <i class="btn-add-round"></i> <span>Adicionar novo valor</span>
              </span>
            </button>
          </div>
        </div>

        <div *ngIf="aplica.value == 'G'">
          <strong>Brinde</strong>
          <label>Selecione os produtos para o brinde</label>
          <div class="form-col-2">
            <button
              (click)="openModalProducts('G')"
              type="button"
              class="btn btn-primary-outline btn-tag"
            >
              <b *ngIf="produtosGratis.length > 0">{{
                produtosGratis.length
              }}</b>
              Pesquisar produtos
            </button>
          </div>
        </div>

        <div *ngIf="aplica.value != 'C'">
          <strong>Limite</strong>
          <label>Limite para aplicar a promoção</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              formControlName="tipo_limite"
              [items]="tipo_limite_list"
              (change)="onChangeDetail()"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div class="tipo_desconto">
              <input
                *ngIf="tipo_limite.value == 'V'"
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control ti20"
                formControlName="investimento_maximo"
                currencyMask
                placeholder="0"
              />
              <input
                *ngIf="tipo_limite.value == 'Q'"
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control"
                formControlName="quantidade_maxima"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                placeholder="0"
              />
              <span *ngIf="tipo_limite.value == 'V'" class="valor">R$</span>
            </div>
          </div>
        </div>

        <div>
          <strong>Validade</strong>
          <div class="form-col-2 mb20">
            <div>
              <label>Data de início</label>
              <div class="frm-datepicker">
                <input
                  type="text"
                  formControlName="dt_inicio"
                  class="form-control"
                  (dateInput)="onChangeDetail()"
                  [matDatepicker]="pickerInicialDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerInicialDate"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #pickerInicialDate
                  [startAt]="startDate"
                ></mat-datepicker>
              </div>
            </div>
            <div>
              <label>Hora de início</label>
              <div class="hora_inicial">
                <input
                  type="text"
                  class="form-control"
                  matInput
                  formControlName="hora_inicial"
                  (keyup)="onChangeDetail()"
                  mask="Hh:m0"
                  [dropSpecialCharacters]="false"
                  placeholder="00:00"
                />
                <i class="ic ic-clock-gray"></i>
              </div>
            </div>
          </div>
          <mat-radio-group
            aria-label="Select an option"
            formControlName="flag_final"
            (change)="onChangeDetail()"
            class="mb20"
          >
            <mat-radio-button *ngIf="aplica.value != 'C'" value="L"
              >O término ocorrerá apenas quando o limite for
              alcançado</mat-radio-button
            >
            <mat-radio-button value="D"
              >Definir uma data para expirar</mat-radio-button
            >
          </mat-radio-group>
          <div *ngIf="flag_final.value == 'D'" class="form-col-2">
            <div>
              <label>Data de expiração</label>
              <div class="frm-datepicker">
                <input
                  type="text"
                  formControlName="dt_expiracao"
                  [min]="dt_inicio.value"
                  (dateInput)="onChangeDetail()"
                  class="form-control"
                  [matDatepicker]="pickerExpiracaoDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerExpiracaoDate"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #pickerExpiracaoDate
                  [startAt]="startDate"
                ></mat-datepicker>
              </div>
            </div>
            <div>
              <label>Hora de expiração</label>
              <div class="hora_expiracao">
                <input
                  type="text"
                  class="form-control"
                  formControlName="hora_expiracao"
                  (keyup)="onChangeDetail()"
                  matInput
                  mask="Hh:m0"
                  [dropSpecialCharacters]="false"
                  placeholder="00:00"
                />
                <i class="ic ic-clock-gray"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </section>
  </form>

  <div *ngIf="showModal" class="modal" [class.open]="openModal">
    <div class="modal-content modal-medium">
      <header>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="strSearch"
          (keydown)="resetPageSearch()"
          (keyup)="searchTerm$.next($event.target.value)"
          placeholder="Buscar produtos..."
        />
        <i class="ic ic-magnifying"></i>
        <a class="btn-close dnone"></a>
      </header>
      <section
        infiniteScroll
        [infiniteScrollDistance]="2"
        [scrollWindow]="false"
        [infiniteScrollThrottle]="20"
        (scrolled)="onScroll()"
      >
        <div
          *ngFor="let product of products; let i = index"
          [class.active]="product.selected"
          (click)="selectProduct(product)"
        >
          <figure>
            <img
              [src]="product.image"
              onerror="this.onerror=null;this.src='/assets/img/produto_sem_foto.png'"
            />
            <b class="check"></b>
          </figure>
          <div class="description">
            <span>{{ product.descricao }}</span>
            <strong>{{ product.codbarra | mask: "0 000000 000000" }}</strong>
          </div>
          <div class="price">R$ {{ product.preco | number: ".2" }}</div>
        </div>

        <div
          class="loading"
          *ngIf="loadingProducts"
          [class.loading-inital]="page == 1"
        >
          <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
            <div class="ldio-ns36390yc">
              <div></div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <span *ngIf="modalType == 'P'"
          >{{ produtosSelected.length + produtos.length }} selecionado</span
        >
        <span *ngIf="modalType == 'G'"
          >{{
            produtosGratisSelected.length + produtosGratis.length
          }}
          selecionado</span
        >
        <button
          (click)="closeModalProducts()"
          type="button"
          class="btn btn-primary-outline"
        >
          CANCELAR
        </button>
        <button (click)="putProducts()" type="button" class="btn btn-primary">
          ATRIBUIR
        </button>
      </footer>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
